<div class="logo"><a href="/project"><img src="@/assets/img/logo_imqa.svg" alt="IMQA"></a></div>